/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statstitle1Inputs */

const en_statstitle1 = /** @type {(inputs: Statstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key figures`)
};

const de_statstitle1 = /** @type {(inputs: Statstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kennzahlen`)
};

/**
* | output |
* | --- |
* | "Key figures" |
*
* @param {Statstitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statstitle1 = /** @type {((inputs?: Statstitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statstitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statstitle1(inputs)
	return de_statstitle1(inputs)
});
export { statstitle1 as "statsTitle" }